<div class="content-container">
    <div class="content d-flex flex-wrap">
        <button class="mwp-button me-3 me-3 mb-3">
            Standard
        </button>
        <button class="mwp-button-secondary me-3 mb-3">
            Secondary - Go Back, Cancel
        </button>
        <button class="mwp-button-red me-3 mb-3">
            Red / Delete
        </button>
        <button class="mwp-button-red alternate-hover me-3 mb-3">
            Red / Delete Alt Hover
        </button>
        <button class="mwp-button-green me-3 mb-3">
            Green / Save
        </button>
        <button class="mwp-button-green alternate-hover me-3 mb-3">
            Green / Save Alt Hover
        </button>
        <button class="mwp-button-orange me-3 mb-3">
            Orange
        </button>
        <button class="mwp-button-orange alternate-hover me-3 mb-3">
            Orange Alt Hover
        </button>
        <button class="mwp-button disabled me-3 me-3 mb-3">
            Disabled for all buttons
        </button>
    </div>
</div>